import React, { Component } from 'react';

let nextOrder = {
    default: 'asc',
    asc: 'desc',
    desc: 'default',
};

export default function sortTable(Table) {
    return class SortTable extends Component {
		orderBy = '';

		order = 'default';

		get(row, key) {
		    return (
		        row[key] || (row.values && row.values[key] && (row.values[key].value || row.values[key].display)) || ''
		    );
		}

		toNumberIfNeed(num) {
		    // return isNaN(Number(num)) ? num : Number(num);
		    return num;
		}

		render() {
		    let { columns, data, customSort } = this.props;
		    return (
		        <Table
		            {...this.props}
		            data={
		                this.order !== 'default' && this.orderBy ? (
		                    [...data].sort((a, b) => {
		                        if (customSort && typeof customSort[this.orderBy] === 'function') {
		                            return customSort[this.orderBy](this.order, a, b);
		                        }
		                        if (this.order === 'asc') {
		                            // 升序
		                            return this.get(a, this.orderBy).localeCompare(this.get(b, this.orderBy));
		                        } else if (this.order === 'desc') {
		                            // 降序
		                            return this.get(b, this.orderBy).localeCompare(this.get(a, this.orderBy))
		                        }
		                        return;
		                    })
		                ) : (
		                    data
		                )
		            }
		            columns={columns.map(e => {
		                e.attrcode = e.attrcode || e.key;
		                if (e.__type__ === 'commonColumn') {
		                    e._title = e._title || e.title;
		                    e.title = <>
		                        {e._title}
		                        <i
		                            className={`uf ${(e.key === this.orderBy &&
										{
										    default: 'uf-symlist',
										    asc: 'uf-sortup',
										    desc: 'uf-sortdown',
										}[this.order]) ||
										'uf-symlist'} refer-sort-icon`}
		                            style={{ marginLeft: -20 }}
		                            onClick={() => {
		                                if (this.orderBy !== e.key) {
		                                    this.order = 'default';
		                                    this.orderBy = e.key;
		                                }
		                                this.order = nextOrder[this.order || 'default'];
		                                this.forceUpdate();
		                            }}
		                        />
		                    </>;
		                }
		                return e;
		            })}
		        />
		    );
		}
    };
}
